import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUserTasksCapacity } from '@nimbus-global/features/user-tasks-capacity/models/user-tasks-capacity.model';
import { IUserTasksCapacityService } from '@nimbus-global/features/user-tasks-capacity/services/i-user-tasks-capacity.service';
import { AssistantHub } from './signalr/assistant.hub';

@Injectable()
export class AssistantUserTasksCapacityService implements IUserTasksCapacityService {
  public readonly capacity$: Observable<IUserTasksCapacity>;

  public constructor(private readonly assistantHub: AssistantHub) {
    this.capacity$ = this.assistantHub.taskCapacity$;
  }

  public initialize(): void {
    // The AssistantHub manages its own lifecycle; no explicit initialization needed.
  }
}
